var map = {
	"./DOE-AL/logo_diario.png": "+Z2+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JYW+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens ^\.\/.*\/logo_diario\.png$
// module id = JYW+
// module chunks = 1